export default __webpack_public_path__ + "static/media/feeling_4_mobile_view.e23ab052.svg";